import React, { useState } from "react";
import { toast } from "sonner";
import { FileSpreadsheet, FileText, Loader2 } from "lucide-react";
import { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { downloadBlob } from "@/components/hr/hrUtils";

const firstOfYear = () => `${new Date().getFullYear()}-01-01`;
const today = () => new Date().toISOString().slice(0, 10);

export function InvoiceExport({ open, onOpenChange }) {
  const [from, setFrom] = useState(firstOfYear());
  const [to, setTo] = useState(today());
  const [busy, setBusy] = useState("");
  const go = async (kind, ext) => {
    setBusy(kind);
    const qs = `?date_from=${from}&date_to=${to}`;
    const url = kind === "fec" ? `/invoices/export/fec.txt${qs}` : `/invoices/export/journal.${ext}${qs}`;
    const name = kind === "fec" ? `FEC_achats_${to.replace(/-/g, "")}.txt` : `journal-achats_${from}_${to}.${ext}`;
    try { await downloadBlob(url, name); } catch (e) { toast.error(apiErr(e)); } finally { setBusy(""); }
  };
  const B = ({ k, ext, icon: Icon, label }) => (
    <Button data-testid={`invoice-export-${k}`} variant="outline" disabled={!!busy} onClick={() => go(k === "fec" ? "fec" : "journal", ext)} className="w-full justify-start rounded-2xl py-6">
      {busy && busy === (k === "fec" ? "fec" : "journal") ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Icon className="mr-2 h-4 w-4 text-[#065F46]" />}{label}
    </Button>
  );
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-3xl sm:max-w-md" data-testid="invoice-export-dialog">
        <DialogHeader><DialogTitle className="font-display text-xl">Export comptable</DialogTitle></DialogHeader>
        <p className="text-sm text-gray-500">Factures validées dont la date de facture est comprise dans la période.</p>
        <div className="grid grid-cols-2 gap-3">
          <div><Label className="text-xs text-gray-500">Du</Label><Input data-testid="invoice-export-from" type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="mt-1 rounded-xl" /></div>
          <div><Label className="text-xs text-gray-500">Au</Label><Input data-testid="invoice-export-to" type="date" value={to} onChange={(e) => setTo(e.target.value)} className="mt-1 rounded-xl" /></div>
        </div>
        <div className="space-y-2 pt-1">
          <B k="xlsx" ext="xlsx" icon={FileSpreadsheet} label="Journal des achats (Excel)" />
          <B k="csv" ext="csv" icon={FileSpreadsheet} label="Journal des achats (CSV)" />
          <B k="fec" icon={FileText} label="Écritures préparées (format FEC)" />
          <Button data-testid="invoice-export-by-account" variant="outline" onClick={async () => { try { await downloadBlob(`/accounting/export/by-account.xlsx?date_from=${from}&date_to=${to}`, `depenses-par-compte_${from}_${to}.xlsx`); } catch (e) { toast.error(apiErr(e)); } }} className="w-full justify-start rounded-2xl py-6"><FileSpreadsheet className="mr-2 h-4 w-4 text-[#065F46]" />Dépenses par compte et analytique (Excel)</Button>
        </div>
        <p className="text-[11px] text-gray-500">Les factures dont l'imputation est validée sont ventilées ligne par ligne sur leurs comptes ; selon le régime choisi dans Pré-comptabilité (BNC : factures réglées à la date du règlement). Ce fichier prépare les écritures pour votre expert-comptable : ce n'est pas un FEC réglementaire.</p>
      </DialogContent>
    </Dialog>
  );
}
